import type { FC } from 'react';

import { SECTION_IDS } from '@/features/home/constants/home.constants';
import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { WhyShoutt, WhyUsPoint } from '@/types/home.types';

interface WhySectionProps {
  whyShoutt: WhyShoutt;
  points: WhyUsPoint[];
}

const WhySection: FC<WhySectionProps> = ({ whyShoutt, points }) => (
  <section id={SECTION_IDS.story} className="scroll-mt-20 bg-site-bg">
    <div className={`${SITE_CONTAINER} pb-14 md:pb-[72px]`}>
      {/* The 2px gap on an ink background is what draws the hairline between panels. */}
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,380px),1fr))] gap-0.5 border-2 border-site-ink bg-site-ink">
        <div className="flex flex-col gap-4 bg-site-accent-soft p-6 md:p-[clamp(24px,4vw,40px)]">
          <span className="font-site text-[13px] tracking-[0.08em] text-site-accent-deep uppercase">
            {whyShoutt.eyebrow}
          </span>
          <p className="font-site text-[clamp(22px,2.2vw,28px)] leading-[1.25] font-extrabold tracking-[-0.01em]">
            {whyShoutt.lead}
          </p>
          <p className="font-site text-base leading-[1.5] text-site-ink/80">{whyShoutt.body}</p>
        </div>

        <div className="bg-site-bg p-6 md:p-[clamp(24px,4vw,40px)]">
          <span className="mb-2 block font-site text-[13px] tracking-[0.08em] text-site-accent-deep uppercase">
            Why us
          </span>

          <ol>
            {points.map((point, index) => (
              <li
                key={point.step}
                className={`grid grid-cols-[56px_minmax(0,1fr)] gap-4 py-5 ${
                  index === 0 ? '' : 'border-t-2 border-site-line'
                }`}
              >
                <span className="font-site text-[32px] leading-none font-extrabold text-site-accent">
                  {point.step}
                </span>
                <div>
                  <div className="font-site text-[19px] font-extrabold">{point.title}</div>
                  <p className="mt-1.5 font-site text-[15px] leading-[1.5] text-site-ink/80">
                    {point.body}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default WhySection;
